import React, { useEffect } from 'react';
import { Outlet, useParams, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from '../locales/languages';
import MenuOptions from './menuOptions';
import Footer from './footer';
import HreflangTags from './HreflangTags';

const LanguageLayout = () => {
  const { lang } = useParams();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (SUPPORTED_LANGUAGES.includes(lang) && i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
    document.documentElement.lang = lang;
  }, [lang, i18n]);

  if (!SUPPORTED_LANGUAGES.includes(lang)) {
    return <Navigate to="/es/404" replace />;
  }

  return (
    <>
      <HreflangTags />
      <MenuOptions />
      <Outlet />
      <Footer />
    </>
  );
};

export default LanguageLayout;
